module.exports = __webpack_public_path__ + "img/tachinha.17e5b631.svg";